/**
 * Module - Show Card - English
 */
export default {
  showCard: {
    // cardShow - Account upgrade dialog
    cardShow: 'Account Upgrade',
    dingTalkStep1: 'Please log in to DingTalk with the mobile number you submitted in the previous step',
    dingTalkStep2: 'The system has sent you a team invitation to join headquarters',
    dingTalkStep3: 'Account upgrade will be completed after accepting the invitation',
    agreedInvite: 'Already accepted? Try',
    complete: 'Complete',
    mergeAccount: 'Merge Accounts',
    addAgentAccountTip: 'Please add your agent account',
    accountLabel: 'Account:',
    pleaseEnterAccount: 'Enter account',
    passwordLabel: 'Password:',
    pleaseEnterPassword: 'Enter password',
    addAccountBtn: 'Add Account',
    back: 'Back',
    upgradeSuccess: 'Account Upgrade Successful',
    upgradeSuccessTip: 'You can log in from',
    upgradeSuccessTip2: 'to experience the upgraded features.',
    loginWithNewAccount: 'Login with new account',
    accountAlreadyAdded: 'This account has been added, please do not repeat',
    pleaseEnterAccountPassword: 'Please enter account and password',
    addSuccess: 'Add successful',
    addFailed: 'Add failed',
    refreshed: 'Refreshed',

    // upgradeDetails
    upgradeDetails: 'Upgrade Details',
    dealerParticipateTip: 'Dealers participate in upgrade/downgrade assessment. For indicators and rules, see:',
    assessmentDetail: 'Assessment Details!',
    performanceShortfallKeep: 'Performance gap to keep level',
    performanceShortfallUpgrade: 'Performance gap to upgrade',

    // advertiseMessage
    objectionSubmit: 'Objection Submit',
    advertiseMessage: 'Announcements',
    setEmergencyContact: 'Set Emergency Contact',
    viewDetail: 'View Detail',
    downloadAttachment: 'Download Attachment',
    objectionContent: 'Objection Content',
    viewObjectionContent: 'View Objection Content',
    objectionContentLabel: 'Objection Content:',
    objectionPlaceholder: 'Please fill in your objection about the announcement',
    close: 'Close',
    noAttachment: 'No attachment for this announcement',
    download: 'Download',
    viewNoticeDetail: 'View Announcement Details',
    giveUpRights: 'Give Up Rights',
    skip: 'Skip >',
    pleaseEnterPhoneForRecovery: 'Enter account phone for recovery',
    pleaseEnterValidPhone: 'Enter valid phone number',
    pleaseEnterVerifyCode: 'Enter verification code',
    verifyCodeFormatError: 'Invalid verification code format',
    pleaseEnterPhone: 'Enter phone number',
    sendSuccess: 'Sent successfully',
    requestFailed: 'Request failed',
    operationFailed: 'Operation failed',
    closeButton: 'Close',
    closeWithCountdown: 'Close ({n}s)',
    objectionContact: 'If you have any objection, please contact me',
    objectionLengthTip: 'Please enter objection content between 10-100 characters',
    submitSuccess: 'Submitted successfully',
    submitFailed: 'Submit failed',

    // commodityRatioMsg
    commodityRatioMsg: 'Commodity Ratio',
    autoOrderRatioTitle: 'Auto Order Commodity Ratio Maintenance',
    agentId: 'Agent ID:',
    ratioTip: '*Please maintain model ratios accurately. Auto orders will allocate amounts based on these ratios! Total ratio must equal 100%.',
    modelName: 'Model Name',
    ratio: 'Ratio',
    ratioTotal: 'Total',
    pleaseEnterRatio: 'Enter ratio',
    updateLog: 'Update Log:',
    ratioValidationError: 'Please enter valid ratio: integer 1-100, total must equal 100%',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',

    // AdvertiseMessage config
    noticeTitle: 'Notice Title',
    pleaseEnterNoticeTitle: 'Enter notice title',
    noticeType: 'Notice Type',
    pleaseSelectNoticeType: 'Select notice type',
    urgencyLevel: 'Urgency',
    pleaseSelectUrgencyLevel: 'Select urgency',
    readStatus: 'Status',
    pleaseSelectStatus: 'Select status',
    sendTime: 'Send Time',
    readTime: 'Read Time',
    studentAccount: 'Student Account',
    studentName: 'Student Name',
    campusId: 'Campus ID',
    campusName: 'Campus Name',
    performanceType: 'Performance Type',
    q1Performance: 'Q1 Performance',
    q2Performance: 'Q2 Performance (Cumulative)',
    q2Remark: '(incl. Q1)',
    q3Performance: 'Q3 Performance (Cumulative)',
    q3Remark: '(incl. Q1, Q2)',
    q4Performance: 'Q4 Performance (Cumulative)',
    q4Remark: '(incl. Q1, Q2, Q3)',
    upgradeGap: 'Upgrade Gap'
  }
}
